<template>
    <div class="modal" v-if="seen">
        <div class="deletefile" style="width: 520px;">
            <span @click="closebox" class="closefile">
                <svg style="width:24px;height:24px" viewBox="0 0 24 24">
                    <path fill="#000000" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
                </svg>
            </span>
            <div class="header">
                <h3>{{ user }} has created:</h3>
            </div>
            <div class="cgn">
                <ul class="selected_files">
                    <li v-for="(file, index) in files" :key="index">
                        <span>
                            <svg style="width:12px;height:12px" viewBox="0 0 24 24">
                                <path fill="#0c0" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z" />
                            </svg>
                        </span>
                        &nbsp;
                        {{ file.total + ' ' + file.name }}
                    </li>
                </ul>
            </div>
            <div>
                <span class="btn btn-primary mr-2" @click="archive">
                    <svg style="width:15px;height:15px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M3,3H21V7H3V3M4,8H20V21H4V8M9.5,11A0.5,0.5 0 0,0 9,11.5V13H15V11.5A0.5,0.5 0 0,0 14.5,11H9.5Z" />
                    </svg>
                    <span class="ml-1">Archive User Files</span>
                </span>
                <span class="btn btn-danger" @click="deleteuser">
                    <svg style="width:16px;height:16px" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                    </svg>
                    <span class="ml-1">Delete User & Files</span>
                </span>
            </div>
        </div>
    </div>
</template>
<style scoped>
.btn {
    cursor: pointer;
    font-size: 14px;
    padding: .5em .9em;
    display: flex;
    justify-content: center;
    align-items: center;
}
.header {
    padding-bottom: .4em !important;
}
.header h3 {
    font-size: 22px;
    margin-bottom: 0 !important;
}
.cgn {
    margin-top: 0 !important;
    font-size: 15px !important;
}
.cgn ul li {
    font-size: 15px !important;
}
</style>
<script>
import cookies from '@/services/cookies'
export default {
  data () {
    return {
      seen: false,
      files: [],
      user: '',
      id: '',
      index: 0
    }
  },
  methods: {
    load (files, user, index, id) {
      this.seen = true
      this.user = user
      this.files = files
      this.id = id
      this.index = index
    },
    notify (msg) {
      this.$parent.notify(msg)
    },
    logincall () {
      this.$parent.logincall()
    },
    archiveuserloader () {
      this.$parent.archiveuserloader()
    },
    closearchiveuserloader () {
      this.$parent.closearchiveuserloader()
    },
    archive () {
      let that = this

      let data = {
        token: cookies.getCookie('token'),
        id: this.id
      }

      console.log(data)

      this.archiveuserloader()
      this.seen = false

      this.$socket.emit('archive-user', data, function (data) {
        if (data.data === true) {
          that.closearchiveuserloader()
          that.notify('User has been archived')
        } else {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    deleteuserloader () {
      this.$parent.deleteuserloader()
    },
    closeuserdeleteloader () {
      this.$parent.closedeleteuserloader()
    },
    deleteuser () {
      let data = {
        token: cookies.getCookie('token'),
        id: this.id
      }

      this.deleteuserloader()
      this.seen = false

      let that = this

      this.$socket.emit('delete-user-permanently', data, function (data) {
        if (data.data === true) {
          that.closedeleteuserloader()
        }

        if (data.data === false) {
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    closebox () {
      this.seen = false
    }
  }
}
</script>
